import { cn } from "@/lib/utils";
import { getDestinyTheme } from "@/lib/karma/theme";

export function DestinyBadge({
  destiny,
  className,
  label,
}: {
  destiny: number;
  className?: string;
  label?: string;
}) {
  const theme = getDestinyTheme(destiny);
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-medium",
        theme.softBg,
        className,
      )}
    >
      <span
        className={cn(
          "grid h-6 w-6 place-items-center rounded-full text-[0.75rem] font-semibold",
          theme.badge,
        )}
      >
        {theme.number}
      </span>
      <span className="text-muted-foreground">{label ?? "Kader"}</span>
      <span className={cn("font-semibold", theme.text)}>{theme.name}</span>
    </span>
  );
}
